import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["to"];
import React from 'react';
import { NavLink } from 'react-router-dom';
import NavMenuItem from 'components/NavMenu/NavMenuItem';
export function NavMenuRouterLinkItem(_ref) {
  var to = _ref.to,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(NavMenuItem, _extends({
    as: NavLink,
    to: to,
    activeClassName: "is-active"
  }, otherProps));
}